import { legacyOauthApps } from '../legacyOauthApps';
import { getExperiments } from './experiments';
export const isLegacyInstallerFlow = appId => legacyOauthApps.includes(appId) && !getExperiments().enabled(`spec.dcc.new_installer_for_legacy_oauth_app_id_${appId}`);
//# sourceMappingURL=is-legacy-installer-flow.js.map